import { render, staticRenderFns } from "./ObservationsContainer.vue?vue&type=template&id=6c8c26c8&scoped=true&"
import script from "./ObservationsContainer.vue?vue&type=script&lang=js&"
export * from "./ObservationsContainer.vue?vue&type=script&lang=js&"
import style0 from "./ObservationsContainer.vue?vue&type=style&index=0&id=6c8c26c8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c8c26c8",
  null
  
)

export default component.exports